export default __webpack_public_path__ + "static/media/Check.a347b6b5.svg";